import { render, staticRenderFns } from "./SimulationResults.vue?vue&type=template&id=0773e64a&scoped=true"
import script from "./SimulationResults.vue?vue&type=script&lang=ts"
export * from "./SimulationResults.vue?vue&type=script&lang=ts"
import style0 from "./SimulationResults.vue?vue&type=style&index=0&id=0773e64a&prod&scoped=true&lang=scss"
import style1 from "./SimulationResults.vue?vue&type=style&index=1&id=0773e64a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0773e64a",
  null
  
)

export default component.exports